import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'page-viewdoc',
    templateUrl: './page-viewdoc.component.html',
    styleUrls: ['./page-viewdoc.component.scss'],
})
export class PageViewDoc implements OnInit {
    public url: string;
    constructor() {
    }

    ngOnInit(): void {
        window.addEventListener('storage', (event) => {
          if (event.storageArea != localStorage) return;
          if (event.key === 'urlsource') {
            this.url = localStorage.getItem('urlsource');
          }
        });

        this.url = localStorage.getItem('urlsource');

        window.addEventListener('beforeunload', (event) => {
            this.url = localStorage.getItem('viewMode');
            localStorage.setItem('viewMode', '3');
        });
      }


}
